var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4106_5181",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9034 0H0V16H15.9034V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4106_5181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9036 8.1832C15.9036 7.63937 15.8588 7.09262 15.7634 6.55762H8.11133V9.63827H12.4933C12.3115 10.6319 11.7272 11.5108 10.8717 12.0693V14.0681H13.486C15.0212 12.6748 15.9036 10.6172 15.9036 8.1832Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11102 15.9992C10.299 15.9992 12.1443 15.2908 13.4886 14.0679L10.8744 12.069C10.147 12.557 9.20801 12.8334 8.114 12.8334C5.99752 12.8334 4.20299 11.4252 3.5591 9.53223H0.861328V11.5928C2.23854 14.2944 5.04362 15.9992 8.11102 15.9992Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55582 9.53282C3.21599 8.53926 3.21599 7.46338 3.55582 6.46981V4.40918H0.861035C-0.289616 6.6697 -0.289616 9.33294 0.861035 11.5934L3.55582 9.53282Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11102 3.16546C9.26763 3.14783 10.3855 3.577 11.2231 4.36481L13.5393 2.08076C12.0727 0.722694 10.1261 -0.0239539 8.11102 -0.000437454C5.04361 -0.000437454 2.23854 1.70451 0.861328 4.4089L3.55611 6.46953C4.19701 4.57351 5.99454 3.16546 8.11102 3.16546Z",
    fill: "#EA4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6c5bfc4d23d02b9fb206ec79ea5ce281.svg";
export { ForwardRef as ReactComponent };